import axios from "axios";
import { Base_URL } from "../url";

export const saveTaxCodeDetails = async (taxCodeData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TaxCodesLogistics/CreateTaxCode?username=${username}`,
      taxCodeData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving tax code details!";
  }
};